module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "charset": "utf-8"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "styles/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Volume One")]), _vm._v(" "), _c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Volume One"
    }
  }, [_c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0015-01-0"
    }
  }, [_c('b', [_vm._v("44 ")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', {
    staticClass: "st1"
  }, [_vm._v(" Write “thank you” notes promptly.")])])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0015-01-1"
    }
  }, [_c('b', [_vm._v("45 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v(" Show respect for teachers.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0015-01-2"
    }
  }, [_c('b', [_vm._v("46 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Show respect for police officers and firefighters.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0015-01-3"
    }
  }, [_c('b', [_vm._v("47 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Show respect for military personnel.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0015-P-1"
    }
  }, [_c('b', [_vm._v("48 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Don’t waste time learning the “tricks of the trade.” Instead, learn the trade.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0015-P-2"
    }
  }, [_c('b', [_vm._v("49 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Keep a tight rein on your temper.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0015-01-4"
    }
  }, [_c('b', [_vm._v("50 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Buy vegetables from truck farmers who advertise with hand-lettered signs.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0015-01-5"
    }
  }, [_c('b', [_vm._v("51 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Put the cap back on the toothpaste.")])])]), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0016-P-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('b', [_vm._v("52 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Take out the garbage without being told.")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0016-01-1"
    }
  }, [_c('b', [_vm._v("53 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Avoid overexposure to the sun.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0016-01-2"
    }
  }, [_c('b', [_vm._v("54 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Vote.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0016-01-3"
    }
  }, [_c('b', [_vm._v("55 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Surprise loved ones with little unexpected gifts.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0016-01-4"
    }
  }, [_c('b', [_vm._v("56 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Stop blaming others. Take responsibility for every area of your life.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0016-01-5"
    }
  }, [_c('b', [_vm._v("57 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Never mention being on a diet.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0016-01-6"
    }
  }, [_c('b', [_vm._v("58 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Make the best of bad situations.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0016-01-7"
    }
  }, [_c('b', [_vm._v("59 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Learn to make something beautiful with your hands.")])])]), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0017-P-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('b', [_vm._v("60 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Live so that when your children think of fairness, caring, and integrity, they think of you.")])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0017-01-1"
    }
  }, [_c('b', [_vm._v("61 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Support a high school band.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0017-01-2"
    }
  }, [_c('b', [_vm._v("62 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Admit your mistakes.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0017-01-3"
    }
  }, [_c('b', [_vm._v("63 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Use your wit to amuse, not abuse.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0017-01-4"
    }
  }, [_c('b', [_vm._v("64 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Remember that all news is biased.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0017-01-5"
    }
  }, [_c('b', [_vm._v("65 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Take a photography course.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0017-01-6"
    }
  }, [_c('b', [_vm._v("66 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Let people pull in front of you when you’re stopped in traffic.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx52",
    attrs: {
      "id": "p0017-01-7"
    }
  }, [_c('b', [_vm._v("67 ")]), _vm._v(" "), _c('span', {
    staticClass: "st1"
  }, [_vm._v("Always accept an outstretched hand.")])])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page17"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb8e940a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter6.vue
// module id = 87
// module chunks = 0